import React, { useRef, useState } from 'react';
import {
    Play,
    Pause,
    Volume2,
    VolumeX,
    Maximize2,
    Minimize
} from 'lucide-react';

interface VideoPlayerProps {
    src: string;
    poster?: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ src, poster="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSRqbSVA7IVUmwlKPTnHcJ3hes0RZTJUCP9-50bIlZdw160vKVj-_Bv2ns89i_MGtXYDHE&usqp=CAU" }) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [isFullscreen, setIsFullscreen] = useState(false);

    const togglePlay = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            } else {
                videoRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    const toggleMute = () => {
        if (videoRef.current) {
            videoRef.current.muted = !isMuted;
            setIsMuted(!isMuted);
        }
    };

    const toggleFullscreen = () => {
        if (videoRef.current) {
            if (!isFullscreen) {
                if (videoRef.current.requestFullscreen) {
                    videoRef.current.requestFullscreen();
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                }
            }
            setIsFullscreen(!isFullscreen);
        }
    };

    return (
        <div className="relative bg-black w-full max-w-2xl mx-auto rounded-lg overflow-hidden">
            <video
                ref={videoRef}
                src={src}
                poster={poster}
                className="w-full"
                onEnded={() => setIsPlaying(false)}
            />

            <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 p-2 flex items-center space-x-4">
                <button
                    onClick={togglePlay}
                    className="text-white hover:text-gray-300"
                >
                    {isPlaying ? <Pause size={24} /> : <Play size={24} />}
                </button>

                <button
                    onClick={toggleMute}
                    className="text-white hover:text-gray-300"
                >
                    {isMuted ? <VolumeX size={24} /> : <Volume2 size={24} />}
                </button>

                <button
                    onClick={toggleFullscreen}
                    className="text-white hover:text-gray-300 ml-auto"
                >
                    {isFullscreen ? <Minimize size={24} /> : <Maximize2 size={24} />}
                </button>
            </div>
        </div>
    );
};

export default VideoPlayer;